import { useQuery } from '@tanstack/react-query';
import { measureService } from '../services/measure.service';
import type { ListRecordsResponse, Measure } from '../services/measure.service';

export function useMeasures(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<Measure>>({
    queryKey: ['measures', page, pageSize, filters],
    queryFn: () => measureService.find({ page, pageSize, filters }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useMeasure(id: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<Measure>({
    queryKey: ['measure', id],
    queryFn: () => measureService.findById(id),
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
